import { render, staticRenderFns } from "./OrderImageGallery.vue?vue&type=template&id=83250d96&scoped=true&"
import script from "./OrderImageGallery.vue?vue&type=script&lang=js&"
export * from "./OrderImageGallery.vue?vue&type=script&lang=js&"
import style0 from "./OrderImageGallery.vue?vue&type=style&index=0&id=83250d96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83250d96",
  null
  
)

export default component.exports